const DURATION_RE =
  /^P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?$/;

const UNITS: ReadonlyArray<readonly [singular: string, plural: string]> = [
  ['year', 'years'],
  ['month', 'months'],
  ['day', 'days'],
  ['hour', 'hours'],
  ['minute', 'minutes'],
  ['second', 'seconds'],
];

// Index of the last unit that may be paired with its next-smaller unit
// (minutes are never paired with seconds).
const LAST_PAIRABLE_INDEX = 3;

function unitText(value: number, index: number): string {
  const [singular, plural] = UNITS[index]!;
  return `${value} ${value === 1 ? singular : plural}`;
}

/**
 * Two-unit countdown: the largest non-zero unit, paired with the next unit
 * down only when that unit is non-zero (e.g. "21 days, 7 hours left",
 * "1 day left" for P1DT0H30M). Seconds are never paired.
 */
export function formatTimeRemaining(isoDuration: string | null): string | null {
  if (isoDuration === null) return null;

  const m = DURATION_RE.exec(isoDuration);
  if (!m) return null;

  const values = [1, 2, 3, 4, 5, 6].map((i) => +(m[i] ?? 0));
  const largest = values.findIndex((v) => v > 0);
  if (largest === -1) return 'Ending soon';

  const parts = [unitText(values[largest]!, largest)];
  const next = values[largest + 1] ?? 0;
  if (largest <= LAST_PAIRABLE_INDEX && next > 0) {
    parts.push(unitText(next, largest + 1));
  }

  return `${parts.join(', ')} left`;
}
